export const withDraw = [
  {
    src: require('assets/img/withdraw.png'),
    value: 10
  },
  {
    src: require('assets/img/withdraw.png'),
    value: 50
  },
  {
    src: require('assets/img/withdraw.png'),
    value: 100
  }
];
